import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
import { BASE_URL } from 'core/api/BaseApi'
import { useGetBuffetDishQuery } from 'core/api/BuffetDishApi'
import { IBuffetDishesRequest } from 'core/api/dto/BuffetDishDto'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { createQueryStringSmart } from 'utils/createQueryString'
import { GetFile } from 'utils/getFile'
import { useParamsControl } from 'utils/useParamsControl'

export const useGetBuffetDishData = () => {
  const { t } = useTranslation()
  const [isLoadingLocal, setIsLoadingLocal] = useState<boolean>(false)

  const pageParams = useParamsControl<
    IBuffetDishesRequest,
    keyof IBuffetDishesRequest
  >({
    withPagination: true,
    whiteList: [
      'search',
      'is_archived',
      'ordering',
      'internal_dish_category',
      'name',
      'ids',
      'category_ids',
    ],
  })

  const normalizedOrdering = (() => {
    const ord = pageParams?.ordering
    if (!ord) return undefined
    const ordStr = Array.isArray(ord) ? ord.join(',') : String(ord)
    return ordStr.replace(
      '-standard_temp_min,standard_temp_max',
      '-standard_temp_min,-standard_temp_max',
    )
  })()

  const {
    data: buffetDishesData,
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
  } = useGetBuffetDishQuery(
    {
      ...pageParams,
      ordering: normalizedOrdering,
    },
    { skip: !pageParams },
  )

  const unloadDishesHandler = () => {
    setIsLoadingLocal(true)
    const newPageParams = {
      ...pageParams,
      limit: buffetDishesData?.count,
    }
    const params = createQueryStringSmart(newPageParams)
    GetFile(`${BASE_URL}/buffet_dish/export_dishes_to_file/${params}`)
      .then(() =>
        AppNotification({
          msg: t('Выбранные блюда успешно выгружены!'),
          type: NotificationType.success,
        }),
      )
      .finally(() => setIsLoadingLocal(false))
  }

  return {
    buffetDishesData,
    isLoadingGet,
    isFetchingGet,
    pageParams,
    unloadDishesHandler,
    isLoadingLocal,
  }
}
